export default {
  screens: [
    {
      type: 'intro',
      title: 'Joséphine, muse of the Maison',
      content:
        'Empress Joséphine chose Chaumet to be her official jeweller from 1805, and later became its great inspiration.',
      idYt: 'gQZPa0SdueQ',
      videoCover: 'world/josephine/video.jpg',
      desktop: {
        cover: 'world/josephine/cover-1.jpg'
      },
      mobile: {
        cover: 'world/josephine/mobile-cover-1.jpg',
        contentStyle: { width: '95%' },
        titleStyle: { width: '60%' },
        coverStyle: {
          width: 'auto',
          width: '50%',
          bottom: '0',
          right: '0',
          left: 'inherit',
          position: 'absolute'
        }
      }
    },
    {
      type: 'memento',
      img: 'world/josephine/memento.jpg',
      content:
        'Joséphine was born in the lush green exuberance of Martinique and remained fond of an exotic and colourful style all her life.<br/><br/> She became the reference of her time from her innate taste for art, fashion, decoration and botany.',
      cover: 'world/josephine/cover-2.jpg'
    },
    {
      type: 'shadow',
      desktop: {
        middleImg: 'home/world/josephine.jpg',
        leftImg: 'world/josephine/shadowLeft.jpg',
        cover: 'world/josephine/cover-3.jpg'
      },
      mobile: {
        middleImg: 'home/world/josephine.jpg',
        leftImg: 'world/josephine/shadowLeft.jpg',
        cover: 'world/josephine/mobile-cover-3.jpg',
        coverStyle: {
          width: '62%',
          top: '41%',
          left: '-19%',
          right: 'inherit',
          position: 'absolute'
        }
      },
      content:
        "The art of Joséphine's style has continued to infuse Chaumet's designs, to inspiring the eponymous collection that takes the tiara to inspire a ring."
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/en/worlds/josephine.js